"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@athena-portal/core");
var KeycloakApplicationGuard_1 = require("./services/KeycloakApplicationGuard");
var ErrorPage_1 = require("./pages/ErrorPage");
var messages_1 = require("./messages");
var plugin = {
    getName: function () {
        return "Keycloak guard";
    },
    register: function (extensions, configuration) {
        extensions
            .services
            .bind(core_1.TypeDefs.ApplicationGuard)
            .toConstantValue(new KeycloakApplicationGuard_1.default(configuration));
        extensions
            .routes
            .add({
            path: "/keycloakFeedback",
            component: ErrorPage_1.default,
            exact: false
        });
        extensions.i18n.addMessages(messages_1.default);
    }
};
exports.default = plugin;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-keycloak/dist/index.js
// module id = 2416
// module chunks = 0